import { useBoolean } from '@magnetic/hooks';
import { useState, useEffect } from 'react';

var __defProp = Object.defineProperty;
var __name = (target, value) => __defProp(target, "name", { value, configurable: true });
const useNav = /* @__PURE__ */ __name(({
  initialIsCollapsed = false,
  isIconOnly = false,
  navZIndex = 0
} = {}) => {
  const [openId, _setOpenId] = useState();
  const [openLabel, _setOpenLabel] = useState();
  const [selectedItemId, setSelectedItemId] = useState();
  const [history, setHistory] = useState([]);
  const shouldShowBack = history.length >= 2;
  const goBack = /* @__PURE__ */ __name(() => {
    const nHistory = history.slice(0, -1);
    setHistory(nHistory);
    const curr = nHistory[(nHistory == null ? void 0 : nHistory.length) - 1];
    _setOpenId(curr);
  }, "goBack");
  const setOpenId = /* @__PURE__ */ __name((id) => {
    setHistory(id ? [id] : []);
    _setOpenId(id);
  }, "setOpenId");
  const setOpenLabel = /* @__PURE__ */ __name((label) => {
    _setOpenLabel(label);
  }, "setOpenLabel");
  const setOpenDrawerId = /* @__PURE__ */ __name((id) => {
    setHistory((h) => [...h, id]);
    _setOpenId(id);
  }, "setOpenDrawerId");
  const {
    setValue: setIsCollapsed,
    toggle: toggleCollapsed,
    value: isCollapsed
  } = useBoolean(initialIsCollapsed);
  const {
    setValue: setIsDrawerOpen,
    toggle: toggleIsDrawerOpen,
    value: isDrawerOpen
  } = useBoolean(false);
  const closeDrawer = /* @__PURE__ */ __name(() => {
    setIsDrawerOpen == null ? void 0 : setIsDrawerOpen(false);
    setSelectedItemId(void 0);
    _setOpenId(void 0);
  }, "closeDrawer");
  useEffect(() => {
    if (openId !== void 0) {
      setIsDrawerOpen(true);
    }
  }, [openId, setIsDrawerOpen]);
  return {
    setIsDrawerOpen,
    toggleIsDrawerOpen,
    selectedItemId,
    setSelectedItemId,
    closeDrawer,
    isDrawerOpen,
    selectedIds: [],
    openId,
    openLabel,
    goBack,
    setOpenId,
    setOpenLabel,
    setOpenDrawerId,
    setIsCollapsed,
    toggleCollapsed,
    shouldShowBack,
    isCollapsed,
    isIconOnly,
    navZIndex
  };
}, "useNav");

export { useNav };
//# sourceMappingURL=use-nav.js.map
